import controller from './vd-flag.controller'
import template from './vd-flag.html'

const FlagComponent = {
  bindings: {
    category: '@',
  },
  transclude: true,
  template,
  controller,
}

export default FlagComponent
